import { CLASSNAMES } from "@constants";

/**
 * Handle collapse
 *
 * @param container {HTMLElement} container element
 */

const Collapse = (item: HTMLElement) => {
  item.addEventListener("click", (event) => {
    event.preventDefault();
    item.classList.toggle(CLASSNAMES.ACTIVE);
    document.getElementById(item.dataset.target).classList.toggle(CLASSNAMES.ACTIVE);
    item.setAttribute(
      "aria-expanded",
      item.getAttribute("aria-expanded") === "true" ? "false" : "true"
    );
  });
};

export default Collapse;
